import script from "./pendingExamine.vue?vue&type=script&setup=true&lang=js"
export * from "./pendingExamine.vue?vue&type=script&setup=true&lang=js"

import "./pendingExamine.vue?vue&type=style&index=0&id=26fd482c&lang=scss"

const __exports__ = script;

export default __exports__